import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";
import {
  campaignAddProduct,
  campaignPrice,
  campaignWithdrawn,
  getCampaignProducts,
  getMarketindDetail,
    getMarketingInvitation,
    getMarketingRegistered,
    registerCampaign,
} from "../../helpers/backend_helper";

type RegisteredParams = {
  page: number;
  count: number;
  campaignId: string;
};

export const getMarketingInvitationThunk = createAsyncThunk(
    "marketingInvitationCampaign/get",
    async () => {
      try {
        const response = await getMarketingInvitation();
        return response.data;
      } catch (error) {
        throw error;
      }
    }
);
  
export const getProductGetThunk = createAsyncThunk(
  "marketingInvitationCampaign/productGet",
  async ({ page, count ,campaignId,keyword,status,categoryId,keywordType}: { page: number; count: number,campaignId:any,keyword:any,status:any,categoryId:any ,keywordType:any}, thunkAPI) => {
    try {
      const response = await getCampaignProducts(page, count,campaignId,keyword,status,categoryId,keywordType);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);



export const registerThunk = createAsyncThunk(
  "marketingInvitationCampaign/register",
  async ({campaignId}: {campaignId: string;}) => {
    try {
      const response = await registerCampaign(campaignId);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export const campaignPriceThunk = createAsyncThunk(
  "marketingInvitationCampaign/campaignPrice",
  async ({subProductId,campaignId, campainPrice}: {subProductId:any,campaignId:any, campainPrice:any}) => {
    try {
      const response = await campaignPrice(subProductId,campaignId, campainPrice);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export const campaignAddProductThunk = createAsyncThunk(
  "marketingInvitationCampaign/AddProduct",
  async ({subProductIds ,campaignId}: {subProductIds :any,campaignId:any}) => {
    try {
      const response = await campaignAddProduct(subProductIds ,campaignId);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export const campaignWithdrawnThunk = createAsyncThunk(
  "marketingInvitationCampaign/campaignWithdrwan",
  async ({subProductId,campaignId, reason}: {subProductId:any,campaignId:any,reason:any}) => {
    try {
      const response : any = await campaignWithdrawn(subProductId,campaignId,reason);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export const fetchMarketingDetail = createAsyncThunk(
  "marketingInvitationCampaign/fetchMarketingDetail",
  async (id: any | number, { rejectWithValue }) => {  
    try {
      const response = await getMarketindDetail(id);  
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);


export const getRegisteredCampaignThunk = createAsyncThunk(
    "marketingInvitationCampaign/getRegistered",
    async (
      params: RegisteredParams,
      { rejectWithValue }
    ) => {
      try {
        const response = await getMarketingRegistered(
          params.page,
          params.count,
          params.campaignId,
        );
        return response.data;
      } catch (error) {
        return rejectWithValue("Something went wrong while fetching vouchers.");
      }
    }
  );
 